export function processLoadThreads(jobId) {
    console.log(jobId);
    return Promise.resolve({ foo: 'bar' });
}
